"use client";
import { Switch } from "antd";

import CommonSearchMobile from "app/(new-pages)/components/Search/mobile/index.mobile";
import useSearch, { handleFilterSuggestionList } from "../useSearch";
import FilterMobile from "../../Filters/mobile/index.mobile";

import styles from "../../../style/index.mobile.module.scss";
import LocationSelectMobile from "app/(new-pages)/components/allSelect/LocationSelect/mobile";
import classNames from "classnames";
// import Web3JobFunctionSelectMobile from "app/(new-pages)/components/allSelect/Web3JobFunctionSelect/mobile/index.mobile";
import SingleSelectMobile from "app/(new-pages)/components/allSelect/baseSelect/mobiles/SingleSelect";
import JobFunctionSelectMobile from "app/(new-pages)/components/allSelect/JobFunctionSelect/mobile/index.mobile";
import useSearchHistory from "helpers/useSearchHistory";

const SearchMobile = ({ config, searchParams, params, dictionary }) => {
  const {
    query,
    setQuery,
    reload,
    input_text,
    suggestionList,
    setSuggestionList,
    sortFilter,
    locationValue,
    setLocationValue,
    jobFunction,
    setJobFunction,
    language,
    setLanguage,
    isRemote,
    setIsRemote,
    handleClearAll,
    sort,
    setSort
  } = useSearch(config, searchParams, params);
  const [, , removeHistory] = useSearchHistory();

  const {
    location_filter = [],
    main_function_filter = [],
    job_function_h5_text,
    search_country_text,
    open_country_region_h5_text,
    search_job_function_text
  } = config;

  const handleClear = (value, type) => {
    if (type !== "history") return;
    let newSuggestionList = suggestionList.filter((item) => {
      if (item.type) return item;
      if (item?.label !== value?.data?.label) return item;
    });
    // console.log("newSuggestionList", newSuggestionList);
    setSuggestionList(newSuggestionList);
    removeHistory(value?.data?.label);
  };

  return (
    <div className={styles.search}>
      <CommonSearchMobile
        setQuery={setQuery}
        query={query}
        placeholder={input_text}
        suggestionList={suggestionList}
        onSearch={reload}
        onClear={handleClear}
        inputOptions={{
          companyGroupText: dictionary?.remotePage?.companyGroupText,
          jobTitleGroupText: dictionary?.remotePage?.jobTitleGroupText,
          historyGroupText: dictionary?.remotePage?.historyGroupText,
          popularJobsText: dictionary?.remotePage?.popularJobsText
        }}
      />

      <div className={styles.filter}>
        <div className={classNames({ [styles.defaultFiled]: true })}>
          <LocationSelectMobile
            location_filter={location_filter}
            value={locationValue}
            onChange={setLocationValue}
            search_country_text={search_country_text}
            location_text={open_country_region_h5_text}
          />
        </div>

        <div className={classNames({ [styles.defaultFiled]: true })}>
          <JobFunctionSelectMobile
            main_function_filter={main_function_filter}
            value={jobFunction}
            onChange={setJobFunction}
            // search_job_function_text={search_job_function_text}
            // main_function_text={job_function_h5_text}
          />
        </div>

        <div className={classNames({ [styles.defaultFiled]: true })}>
          <SingleSelectMobile
            options={sortFilter}
            variant='borderless'
            value={sort}
            onChange={setSort}
          />
        </div>

        {/* <div className={classNames({ [styles.defaultFiled]: true, [styles.switch]: true })}>
          <Switch checked={isRemote} onChange={setIsRemote} />
          <span className={styles.describe}>{remote_only_text}</span>
        </div> */}

        <div className={classNames({ [styles.defaultFiled]: true })}>
          <FilterMobile
            config={config}
            locationValue={locationValue}
            setLocationValue={setLocationValue}
            jobFunction={jobFunction}
            setJobFunction={setJobFunction}
            language={language}
            setLanguage={setLanguage}
            sort={sort}
            setSort={setSort}
            handleClearAll={handleClearAll}
            reload={reload}
            isRemote={isRemote}
            setIsRemote={setIsRemote}
          />
        </div>
      </div>
    </div>
  );
};

export default SearchMobile;
